import React, { useState } from "react";
import { ref, set, get } from "firebase/database";
import { db } from "../services/firebase";

function AdminPanel({ currentUID }) {
  const [inputUID, setInputUID] = useState("");
  const [message, setMessage] = useState("");
  const [showPanel, setShowPanel] = useState(false); // Toggle state

  const handleAddAdmin = async () => {
    if (!inputUID) {
      setMessage("❗ Please enter a UID.");
      return;
    }

    try {
      const userRef = ref(db, `users/${inputUID}`);
      const snapshot = await get(userRef);

      if (!snapshot.exists()) {
        setMessage("❌ User not found in database.");
        return;
      }

      const adminRef = ref(db, `admins/${inputUID}`);
      await set(adminRef, true);

      setMessage(`✅ User with UID "${inputUID}" is now an admin.`);
      setInputUID("");
    } catch (err) {
      setMessage("Error: " + err.message);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>🔐 Admin Access</h2>
      <button
        style={{
          backgroundColor: "#6366f1",
          color: "white",
          padding: "10px 16px",
          border: "none",
          borderRadius: "8px",
          marginBottom: "20px",
          cursor: "pointer",
        }}
        onClick={() => setShowPanel(!showPanel)}
      >
        {showPanel ? "🙈 Hide Admin Panel" : "📂 Show Admin Panel"}
      </button>

      {showPanel && (
        <div className="admin-panel-box" style={{
          padding: "20px",
          border: "1px solid #ddd",
          borderRadius: "10px",
          backgroundColor: "#f9f9fc"
        }}>
          <h3>👑 Admin Management Panel</h3>
          <p>Enter the UID of the user you want to promote to admin:</p>
          <input
            type="text"
            placeholder="Enter Firebase UID"
            value={inputUID}
            onChange={(e) => setInputUID(e.target.value)}
            style={{ padding: "10px", width: "100%", marginBottom: "10px" }}
          />
          <button
            onClick={handleAddAdmin}
            style={{
              backgroundColor: "#4f46e5",
              color: "white",
              padding: "10px 16px",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer"
            }}
          >
            Promote to Admin
          </button>
          {message && <p className="status-msg" style={{ marginTop: "10px" }}>{message}</p>}
        </div>
      )}
    </div>
  );
}

export default AdminPanel;
